import Vue from 'vue'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueCookies);
Vue.use(VueLocalStorage);

const roleClaim = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

const state = {
    accessToken: VueCookies.get('access_token') || null,
    refreshToken: VueCookies.get('refresh_token') || null,
    tokenExpiration: (VueCookies.get('access_token') != null) ? jwtDecode(VueCookies.get('access_token')).exp : 0,
    isAccessTokenValid: false,
    userEmail: (VueCookies.get('access_token') != null) ? jwtDecode(VueCookies.get('access_token')).sub : '',
    userRole: (VueCookies.get('access_token') != null) ? jwtDecode(VueCookies.get('access_token'))[roleClaim] : null
};

const getters = {
    userEmail(state) {
        return state.userEmail;
    },
    userRole(state) {
        return state.userRole;
    },
    isAdmin(state) {
        return state.userRole == "Admin";
    },
    isJwtTokenSet(state) {
        return state.accessToken !== null;
    },
    tokenExpiration(state) {
        return state.tokenExpiration;
    },
    refreshToken(state) {
        return state.refreshToken;
    },
    isAccessTokenValid(state) {
        return state.isAccessTokenValid;
    },
    isAuthenticated(state) {
        return state.accessToken !== null && state.isAccessTokenValid;
    }
};

const mutations = {
    SET_TOKEN(state, token) {
        state.accessToken = token;
    },
    SET_USER_EMAIL(state, email) {
        state.userEmail = email;
    },
    SET_USER_ROLE(state, role) {
        state.userRole = role;
    },
    SET_REFRESH_TOKEN(state, token) {
        state.refreshToken = token;
    },
    SET_TOKEN_EXPIRATION(state, time) {
        state.tokenExpiration = time;
    },
    SET_ACCESS_TOKEN_VALIDATION_STATUS(state, valid) {
        state.isAccessTokenValid = valid;
    }
};

const actions = {
    validateAccessToken(context) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/check")
                .then(response => {
                    context.commit("SET_ACCESS_TOKEN_VALIDATION_STATUS", true);
                    resolve(response);
                })
                .catch(e => {
                    context.commit("SET_ACCESS_TOKEN_VALIDATION_STATUS", false);
                    reject(e);
                })
        });
    },
    validateDoctorsMembership(context) {
        return new Promise((resolve, reject) => {
            axios.post("/api/membership/check")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    validateUserMfa(context) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/check-mfa")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    refreshToken(context) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/token/refresh", {
                    'refreshToken': context.getters.refreshToken
                })
                .then(response => {
                    if (response.data.success == true) {
                        context.commit("SET_TOKEN", response.data.jwt);
                        context.commit("SET_USER_EMAIL", jwtDecode(response.data.jwt).sub);
                        context.commit("SET_USER_ROLE", jwtDecode(response.data.jwt)[roleClaim]);
                        context.commit("SET_TOKEN_EXPIRATION", jwtDecode(response.data.jwt).exp);
                        context.commit("SET_ACCESS_TOKEN_VALIDATION_STATUS", true);
                        VueCookies.set('access_token', response.data.jwt);
                    }

                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })
        });
    },
    retrieveToken(context, credentials) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/login", {
                    'email': credentials.email,
                    'password': credentials.password,
                    'isAdmin': credentials.isAdmin
                })
                .then(response => {
                    if (response.data.success == true) {
                        context.commit("SET_TOKEN", response.data.jwt);
                        context.commit("SET_USER_EMAIL", jwtDecode(response.data.jwt).sub);
                        context.commit("SET_USER_ROLE", jwtDecode(response.data.jwt)[roleClaim]);
                        context.commit("SET_REFRESH_TOKEN", response.data.refreshToken);
                        context.commit("SET_TOKEN_EXPIRATION", jwtDecode(response.data.jwt).exp);
                        context.commit("SET_ACCESS_TOKEN_VALIDATION_STATUS", true);
                        VueCookies.set('access_token', response.data.jwt);
                        VueCookies.set('refresh_token', response.data.refreshToken);
                        context.dispatch('deactivateCga');
                    }

                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })
        });
    },
    retrieveTokenTwoFactor(context, credentials) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/login-2fa", {
                    'email': credentials.email,
                    'password': credentials.password,
                    'twoFactorAuthenticationCode': credentials.twoFactorCode,
                    'isAdmin': credentials.isAdmin
                })
                .then(response => {
                    if (response.data.success == true) {
                        context.commit("SET_TOKEN", response.data.jwt);
                        context.commit("SET_USER_EMAIL", jwtDecode(response.data.jwt).sub);
                        context.commit("SET_USER_ROLE", jwtDecode(response.data.jwt)[roleClaim]);
                        context.commit("SET_REFRESH_TOKEN", response.data.refreshToken);
                        context.commit("SET_TOKEN_EXPIRATION", jwtDecode(response.data.jwt).exp);
                        context.commit("SET_ACCESS_TOKEN_VALIDATION_STATUS", true);
                        VueCookies.set('access_token', response.data.jwt);
                        VueCookies.set('refresh_token', response.data.refreshToken);
                        context.dispatch('deactivateCga');
                    }
                    location.reload();
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })
        });
    },
    destroyTokens(context) {
        return new Promise((resolve, reject) => {
            context.commit("SET_TOKEN", null);
            context.commit("SET_USER_EMAIL", '');
            context.commit("SET_USER_ROLE", null);
            context.commit("SET_REFRESH_TOKEN", null);
            context.commit("SET_TOKEN_EXPIRATION", 0);
            context.commit("SET_ACCESS_TOKEN_VALIDATION_STATUS", false);
            VueCookies.remove('access_token');
            VueCookies.remove('refresh_token');
            resolve();
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};